import antdEnUS from "antd/es/locale/en_US";
import andtdHiIN from "antd/es/locale/hi_IN";
import antdFrFR from "antd/es/locale/fr_FR";
import en from "./locales/en_US.json";
import hi from "./locales/hi_IN.json";
import fr from "./locales/fr_FR.json";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export const resources = {
  en: {
    translation: en,
    antd: antdEnUS,
  },
  hi: {
    translation: hi,
    antd: andtdHiIN,
  },
  fr: {
    translation: fr,
    antd: antdFrFR,
  },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: "en",
  lng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
